import React, { MouseEventHandler, useState } from 'react'

import Logo from './Logo'
import { useCredentials, useLogout } from '@dentalux/security/lib'
import { AppBar, Avatar, Box, IconButton, Menu, MenuItem, Toolbar } from '@mui/material'
import Typography from '@mui/material/Typography'

import MenuIcon from '@mui/icons-material/Menu'

interface Props {
  handleMenuClose: MouseEventHandler
  navItems?: React.ReactNode
}

const NavBar: React.FC<Props> = ({ handleMenuClose, navItems }) => {
  const { authentication: user } = useCredentials()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const logout = useLogout()

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: (theme) => theme.palette.common.white,
        color: (theme) => theme.palette.common.black,
      }}
      elevation={1}
    >
      <Toolbar>
        <IconButton
          sx={{ marginLeft: '-4px', marginRight: '24px' }}
          color="inherit"
          aria-label="open drawer"
          onClick={handleMenuClose}
          edge="start"
        >
          <MenuIcon />
        </IconButton>
        <Logo sx={{ mr: 1 }} />
        <Typography variant="h6">Hades</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>{navItems}</Box>
        {user && (
          <Box>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar alt={user.name} src={user.imgUrl as string} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={logout}>Sign out</MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default NavBar
